<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div
    v-cloak
    class="d-flex  align-center justify-center flex-column"
    style="height: 100%;position: relative"
  >
    <div>
      <div
        class="d-flex  align-center justify-center pa-2 flex-column"
      >
        <v-card
          class="text-center pa-1"
          elevation="0"
          width="100%"
        >
          <v-card-title class="justify-center text-h4 mb-2">
            {{ $t('OptionalLicense') }}
          </v-card-title>
          <v-card-subtitle>
            {{ $t('StartSubscribe') }}
          </v-card-subtitle>
          <v-card-text class="mt-4">
            <template v-if="!loading">
              <v-sheet
                class="mx-auto"
                elevation="0"
              >
                <horizontal-list>
                  <v-card
                    v-for="p in displayProducts"
                    :key="p.id"
                    color="grey lighten-4"
                    elevation="0"
                    style="position: relative;flex-shrink: 0;"
                    width="160"
                    @click="createPayment(p.prices[0].id)"
                  >
                    <v-responsive :aspect-ratio="3/4">
                      <div
                        class="d-flex flex-column justify-center pa-2 align-center text-center"
                        style="height: 100%"
                      >
                        <div class="font-weight-bold text-body-1">
                          {{ p.name }}
                        </div>
                        <div class="mt-2">
                          <div>
                            {{ p.description }}
                          </div>
                        </div>
                        <div class="mt-1 font-weight-bold">
                          {{ p.prices[0].unit_amount / 100 }} €/{{ $t('Month') }}
                        </div>
                      </div>
                    </v-responsive>
                  </v-card>
                </horizontal-list>
              </v-sheet>
            </template>
            <template v-else>
              <div
                class="d-flex flex-column align-center justify-center"
                style="height: 240px;"
              >
                <v-progress-circular indeterminate />
              </div>
            </template>
          </v-card-text>
        </v-card>
      </div>
      <div class="d-flex justify-center align-center mt-2">
        <a @click="changeUser">
          {{ $t('SwitchUser') }}？
        </a>
      </div>
      <div
        class="d-flex flex-column align-center text-caption text--secondary"
        style="width: 100%;position: absolute;left: 0;right: 0;bottom: 48px;"
      >
        <div>
          Aaden POS v {{ version }}
        </div>
        <div>
          Copyright 2023, InnerKen All Rights Reserved.
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { loadProducts } from '@/model/dataLayer/api/SaaS/product'
import { mapState } from 'vuex'
import router from '@/model/global/router'
import { createCheckoutSession } from 'firestore-stripe-payments-jhd'
import { FireBaseAuth, StripePayment } from '@/model/firebase/google-fire-base'
import { determinedActivationStep } from '@/model/dataLayer/api/SaaS/user'
import HorizontalList from '@/views/widget/uiComponent/HorizontalList.vue'

const key = [
  '7', '8', '9',
  '4', '5', '6',
  '1', '2', '3',
  'X', '0', 'C'
]

export default {
  name: 'FirstSubscription',
  components: { HorizontalList },
  props: {
    addProductName: {}
  },
  data: function () {
    return {
      version: require('../../../package.json').version,
      errorAdminPassword: 0,
      input: '',
      key,
      products: [],
      loading: false
    }
  },
  async mounted () {
    this.products = await loadProducts()
    if (this.isAddition) {
      await determinedActivationStep()
    }
  },
  computed: {
    isAddition () {
      return this.license.length !== 0
    },
    ...mapState(['license']),
    displayProducts () {
      return this.products.filter(it => it.metadata?.mainProject === '1' || it.metadata?.mainProject === '3')
    }
  },
  methods: {
    async changeUser () {
      await FireBaseAuth.signOut()
      location.reload()
    },
    async createPayment (priceId) {
      if (priceId === 'price_1MevtKInWSuIJQANIgaTh3mj') {
        await router.push('/oldMember')
      } else {
        await this.changeToPaymentPage(priceId)
      }
    },
    async changeToPaymentPage (priceId) {
      this.loading = true
      const session = await createCheckoutSession(StripePayment, {
        line_items: [
          {
            price: priceId,
            quantity: 1
          }
        ],
        payment_method_types: ['card', 'sepa_debit'],
        allow_promotion_codes: true

      }, { timeoutMillis: 60 * 1000 })
      this.loading = false
      window.location.assign(session.url)
    }
  }
}
</script>

<style scoped>

</style>
